import {styled} from "@mui/material/styles";
import { Chip, FormControl, FormControlLabel } from "@mui/material";
import { useColors } from "../../Context/ColorsContext";

export const CustomFormControl = styled(FormControl)(() => ({
    '& .Mui-disabled': {
        backgroundColor: 'transparent'
    }
}));

export const CustomChip = styled(Chip)(({ theme }) => {
	const { colors } = useColors();
  	return {
		background: "#e1ecf7",
		'.MuiSvgIcon-root': {
			fontSize: 14,
			color: '#29476d',
            marginLeft: 1,
		},
		'.MuiChip-label': {
			paddingLeft: 9,
			paddingRight: 9,
			fontWeight: 'bold',
			color: colors.buttonActionColor,
		},
        color: "#29476d",
        borderRadius: 8,
        fontWeight: 'bold',
        fontSize: '14px',
		[theme.breakpoints.down('md')]: {
			fontSize: '12px',
		},
	}
})

export const ControlLabel = styled(FormControlLabel)(({ theme }) => {
    return {
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      },
      [theme.breakpoints.down('md')]: {
        '& .MuiFormControlLabel-label': {
          fontSize: '12px',
        },
      },
    }
})